import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AdminService } from 'src/app/services/admin-service';
import { environment } from 'src/environments/environment';
import { localDevAccess } from 'src/app/dev-access';
import { of } from 'rxjs';
import { memberPhotosEnabled, showUnfinished } from 'src/app/site-config';

@Component({
  selector: 'pla-admin-page',
  templateUrl: './admin-page.component.html',
  styleUrls: ['./admin-page.component.scss'],
})
export class AdminPageComponent implements OnInit {
  public loaded: boolean = false;
  // Editorial workbench buttons are shown only when the build enables it
  // (dev/dev2). Prod builds set environment.editorialEnabled = false.
  public editorialEnabled: boolean = environment.editorialEnabled;
  public selectedTab: 'yearly-top-sales' | 'sold-search' | 'multiple-sales' | 'comparables' | 'auctions' | 'blog' | 'blog-config' | 'gpt' | 'wordbank' | 'static-media' | 'viewer-config' | 'recently-added' | 'users' | 'founder-cockpit' | 'valuation-lab' | 'dealer-health' | 'plate-photos' = showUnfinished ? 'founder-cockpit' : 'blog';
  // Release hosts show the legacy account page, which has no admin rail, so
  // the tools are picked from a button bar (the production admin tool set).
  public readonly showTabBar = !showUnfinished;
  public readonly releaseTabs: { id: any; label: string }[] = [
    { id: 'yearly-top-sales', label: 'Yearly Top Sales' },
    { id: 'sold-search', label: 'Sold Search' },
    { id: 'multiple-sales', label: 'Multiple Sales' },
    { id: 'blog', label: 'Create Blogs' },
    { id: 'blog-config', label: 'Blog Config' },
    { id: 'static-media', label: 'Media' },
    { id: 'recently-added', label: 'Recently Added Plates' },
    { id: 'viewer-config', label: 'Plate Viewer' },
    { id: 'gpt', label: 'GPT Search' },
    { id: 'wordbank', label: 'Wordbank' },
    { id: 'users', label: 'Users' },
    { id: 'dealer-health', label: 'Dealer Health' },
    ...(memberPhotosEnabled ? [{ id: 'plate-photos', label: 'Plate Photos' }] : []),
  ];

  constructor(
    private adminService: AdminService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    // Check if the user is an admin (localhost developer access skips the check - dev-access.ts)
    const verify$ = localDevAccess ? of({ admin: true }) : this.adminService.verify();
    verify$.subscribe((data: { admin: boolean }) => {
      if (!data.admin) {
        this.router.navigate(['/landing']);
        return;
      }

      this.loaded = data.admin;

      // Get the 'tab' query parameter and set the selectedTab accordingly
      this.route.queryParams.subscribe(params => {
        const tabParam = params['tab'];
        const tabs = ['yearly-top-sales', 'sold-search', 'multiple-sales', 'comparables', 'auctions', 'blog', 'blog-config', 'gpt', 'wordbank', 'static-media', 'viewer-config', 'recently-added', 'users', 'founder-cockpit', 'dealer-health'];
        if (memberPhotosEnabled) tabs.push('plate-photos');
        // Valuation Lab is a DRAFT tool: only on builds with the dev/dev2 flag (never prod).
        if (this.editorialEnabled) tabs.push('valuation-lab');
        if (tabParam && tabs.includes(tabParam)) {
          this.selectedTab = tabParam;
        }
      });
    });
  }

  // Set the selected tab and update the query parameter in the URL
  public SetTab(tab: any): void {
    this.selectedTab = tab;
    this.router.navigate(['/account/admin'], {
      queryParams: { tab: tab },
    });
  }
}
